module.exports = __webpack_public_path__ + "img/modulo_Icon.44c7e7b.svg";